import Vue from 'vue';
import VueAnimated from '@codekraft-studio/vue-animated';

Vue.use(VueAnimated);
